const init = () => {
    addWrapper();
};

const addWrapper = () => {
    document.querySelectorAll('iframe[src*="youtube.com"]').forEach(iframe => {
        const wrapper = document.createElement('div');
        wrapper.className = 'video-wrapper';
        iframe.parentNode.insertBefore(wrapper, iframe);
        wrapper.appendChild(iframe);
    });
};

export default {
    init
};
